import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const Text = ({ value, onChange }) => {
    return (_jsx(_Fragment, { children: _jsx("input", { type: "text", className: "border-2 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline", value: value, onChange: (event) => (onChange) ? onChange(event) : null }) }));
};
